<template>
    <div :class="['hpHero', 'reveal active']" style="width:100%;">
      <div class="hpHeroContent">
          <div class="hero-title msSecTitle" style="color:#202020;letter-spacing:-2px;font-weight:300;">
              {{meta_title}}
              <!-- {{ms_localize(sectionData.title)}} -->
          </div>  
          <div class="hero-desc msSubTitle">
              {{meta_desc}}
              <!-- {{ms_localize(sectionData.desc)}} -->
          </div>        
      </div>
      <div class="scrollerIcon">
        <div class="icon-scroll"></div>
      </div>
      <div class="heroVideoWrapper">
        <video playsinline autoplay muted loop id="videoBgHero"
          :class="['heroVideoConatiner',showVideo ? 'active' : '']">
          <source :src="getVideoUrl()" type="video/mp4">
        </video>
      </div>
  </div>
</template>

<style lang="stylus">
  .icon-scroll,
  .icon-scroll:before
    position: absolute
    left: 50%

  .icon-scroll
    width: 30px
    height: 50px
    margin-left: -20px
    top: 50%
    margin-top: -35px
    box-shadow: inset 0 0 0 1px #fff
    border-radius: 25px

  .icon-scroll:before
    content: ''
    width: 6px
    height: 6px
    background: #fff
    margin-left: -3px
    top: 8px
    border-radius: 4px
    animation-duration: 1.5s
    animation-iteration-count: infinite
    animation-name: scroll

  @keyframes scroll
    0%
      opacity: 1
    100%
      opacity: 0
      transform: translateY(20px)
</style>


<style>
    .hpHero
    {
      position: relative;
    }
    .hpHeroContent
    {
      width: 35vw;
      position: absolute;
      top: calc(50vh - 60px);
      left: 5vw;
      z-index: 10;
      transform: translate(0%,-50%);  
    }
    .scrollerIcon
    {
      width: 40px;
      height: 40px;
      position: absolute;
      top: calc(100% - 110px);
      left: 50%;
      z-index: 10;
      transform: translate(-50%,0%);
    }
    .heroVideoWrapper
    {
      width: 100vw;
      max-height: 100vh;
      height: 100vh;
      overflow: hidden;
    }
    .heroVideoWrapper video
    {
      overflow: hidden;
      position: relative;
      z-index: 1;
      left: 50%;
      top:50%;
      /*       min-width: 100%;
              min-height: 100%;
      */      
      transform: translate(-50%,-50%);
      height: auto;
      width: 100vw;
    }

  @media (hover:hover) {
  }


    @media (max-width: 850px) { 

      .heroVideoWrapper
      {
        width: 100vw;
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
        position: relative;
        padding-top: 0px;
        margin-top: 0px;    
        margin-bottom: 0px;    
        padding-bottom: 0px;
        overflow: hidden;
      }  
      .heroVideoWrapper video {
        height: 100vh;
        max-height: 100vh;
        width: auto;
      }

    }

    @media (max-width: 400px) { 

    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {

    }    
</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines,isMobileScreen }         from "@/utils";
//import splitter from "@/views/com/splitter.vue";

export default 
{  
  components:{/* splitter */},
  props:{
      meta_title:String,
      meta_desc:String
  },
  data(){
      return {
          isMobileLayout:false,
          showVideo:false,
          showBtn:false
      }
  },
  mounted() 
  {
    var vm = this;    
    vm.startAnimation();
    vm.isMobileLayout = isMobileScreen();
    vm.preloadVideo();

    //alert("vm.isMobileLayout="+vm.isMobileLayout);

    //setTimeout(() => {
      //vm.showBtn=true;//start the video after 2 sec
    //}, 200);

    setTimeout(() => {
      vm.showVideo=true;//start the video after 2 sec
    }, 2000);
  },
  methods: {
    preloadVideo()
    {
      const videoElement = document.getElementById("videoBgHero");
      videoElement.addEventListener('loadeddata', (e) => {
        if(videoElement.readyState >= 3){
          ///alert("video ready ");
          //video is now loaded 
        }
    });
    },
    scrollToNextSection()
    {
        document.getElementsByClassName("siteSection")[1].scrollIntoView({ 
          behavior: 'smooth' 
        });

    },
    getVideoUrl()
    {
      //return '';//
        if(isMobileScreen()){
          //img/mguide/videos/MIS_MGUIDE_no_titles
          return this.sectionData.video_mobile_path;// "img/video/MIS_Lance_plus_con_hero_mobile.mp4"
        }else{
          //alert("p="+this.sectionData.video_path);
          return this.sectionData.video_path;
          //return "img/video/MIS_LANCE_plus_Con_hero.mp4";
        }
    },
    startAnimation()
    {
        var vm = this;
    }
  },
  computed: {
    ...mapState(["minisite_data"]),
      sectionData(){
          return this.minisite_data.SECTIONS[0];
      }
    //...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

